// ── Cars Player Controller — Угадай марку ─────────────────────────────────────

const OPTION_COLORS = [
  "bg-[#FF0055] hover:bg-[#FF3377]",
  "bg-[#00AAFF] hover:bg-[#33BBFF]",
  "bg-[#39FF14] hover:bg-[#66FF44]",
  "bg-[#FFFF00] hover:bg-[#FFFF44]",
];
const OPTION_LABELS = ["A", "B", "C", "D"];

export default function CarsPlayer({ options, selectedAnswer, result, onAnswer }) {
  if (!options || !options.length) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center animate-slide-up">
          <div style={{ fontSize: "3.5rem", marginBottom: "1rem", animation: "float 2s ease-in-out infinite" }}>🏎️</div>
          <h2 className="font-display text-2xl text-white mb-2">Угадай марку!</h2>
          <p className="font-heading text-[#aaa]">Смотри на логотип на главном экране</p>
        </div>
      </div>
    );
  }

  const isAnswered = selectedAnswer !== null;

  return (
    <div className="flex-1 flex flex-col animate-slide-up gap-3">

      {/* Подсказка */}
      <div style={{
        background: "#0a0a14",
        border: "2px solid #FF6B0044",
        borderRadius: "0.75rem",
        padding: "0.5rem 1rem",
        textAlign: "center",
      }}>
        <p className="font-heading" style={{ fontSize: "var(--fs-sm)", color: "#FF6B00" }}>
          🏎️ Какая это марка?
        </p>
      </div>

      {/* Статус */}
      {!isAnswered && !result && (
        <div className="text-center">
          <span className="font-display text-lg text-white animate-pulse-neon">Выбери марку!</span>
        </div>
      )}
      {isAnswered && !result && (
        <div className="text-center">
          <span className="font-heading text-[#FF6B00]">✓ Ответ принят — ждём остальных...</span>
        </div>
      )}
      {result && (
        <div className="text-center animate-bounce-in py-2 rounded-2xl font-display text-xl" style={{
          background: selectedAnswer === result.correct ? "#003d20" : "#3d0014",
          border: `2.5px solid ${selectedAnswer === result.correct ? "#3DFF3D" : "#ff3355"}`,
          boxShadow: "3px 3px 0 #000",
          color: selectedAnswer === result.correct ? "#3DFF3D" : "#ff3355",
        }}>
          {selectedAnswer === result.correct ? "✅ Правильно! +100 очков" : "❌ Неверно!"}
        </div>
      )}

      {/* Кнопки вариантов */}
      <div className="grid grid-cols-2 gap-3 flex-1" style={{ alignContent: "start" }}>
        {options.map((opt, i) => {
          const isSelected    = selectedAnswer === i;
          const isThisCorrect = result && result.correct === i;
          const isThisWrong   = result && selectedAnswer === i && result.correct !== i;

          let opacity = 1;
          let outline = "none";
          let shadow  = "4px 4px 0 #000";

          if (result) {
            if (isThisCorrect) { outline = "4px solid #fff"; shadow = "6px 6px 0 #000"; }
            else opacity = 0.4;
          } else if (isSelected) {
            outline = "4px solid #fff";
          } else if (isAnswered) {
            opacity = 0.5;
          }

          return (
            <button
              key={i}
              onClick={() => onAnswer(i)}
              disabled={isAnswered || !!result}
              style={{
                borderRadius: "1.25rem",
                border: "2.5px solid #000",
                boxShadow: shadow,
                outline,
                outlineOffset: "2px",
                padding: "1rem 0.5rem",
                textAlign: "center",
                opacity,
                transition: "all 0.2s",
                cursor: isAnswered || result ? "default" : "pointer",
                WebkitTapHighlightColor: "transparent",
                touchAction: "manipulation",
                background: i === 0 ? "#FF0055" : i === 1 ? "#00AAFF" : i === 2 ? "#39FF14" : "#FFFF00",
              }}
            >
              <div className="font-display" style={{ fontSize: "var(--fs-2xl)", color: "#000", lineHeight: 1 }}>
                {OPTION_LABELS[i]}
              </div>
              <div className="font-heading font-bold" style={{ fontSize: "0.78rem", color: "#000", lineHeight: 1.3, marginTop: "0.25rem" }}>
                {opt}
              </div>
              {isThisCorrect && result && <div style={{ fontSize: "var(--fs-lg)", marginTop: "0.25rem" }}>✅</div>}
              {isThisWrong   && result && <div style={{ fontSize: "var(--fs-lg)", marginTop: "0.25rem" }}>❌</div>}
            </button>
          );
        })}
      </div>
    </div>
  );
}